import {
  Tracker,
  ScoringStorage,
  TrackerLogLevels,
} from '@uniformdev/optimize-tracker-common';
import { DeliveryAPIResult } from '@uniformdev/optimize-common';
import { indexedDbScopeStorage } from '@uniformdev/optimize-tracker-storage-indexeddb';
import { createDefaultTracker } from '@uniformdev/optimize-tracker-browser';
import { NextPageContext } from 'next';
import { cookieScoringStorage } from '@uniformdev/optimize-tracker';
import cookie from 'cookie';

import intentManifest from 'src/__generated__/intentManifest.json';
import { SET_COOKIE_HEADER } from 'constants/constants';
import { Section } from 'src/__generated__/graphqlTypes';

export const mapSectionToUniformSection = (section: Section) => {
  const newSection: any = section;
  newSection.fields = {};
  newSection.sys = {};
  newSection.fields.unfrmOptIntentTag = newSection.unfrmOptIntentTag;
  newSection.fields.sys = newSection.sys;
  newSection.sys.contentType = {
    sys: {
      id: section.sys.id,
    },
  };

  return newSection;
};

const createNextCookieStorage = (ctx?: NextPageContext): ScoringStorage => {
  const cookieStorage = cookieScoringStorage({
    getCookie: (name) => {
      const cookies = cookie.parse(ctx?.req?.headers.cookie || '') || {};

      return cookies[name];
    },

    setCookie: (name, value, maxAge) => {
      if (typeof window === 'undefined') {
        return;
      }

      const cookies = cookie.serialize(
        name,
        value,
        {
          maxAge,
          path: '/',
          sameSite: 'strict',
          secure: window.location.protocol === 'https:',
        },
      );

      ctx?.res?.setHeader(SET_COOKIE_HEADER, cookies);
    },
  });

  return cookieStorage;
};

let logLevelThreshold: TrackerLogLevels = 'error';

if ((global as any)?.__NEXT_DATA__?.nextExport) {
  logLevelThreshold = 'error';
}

export const createLocalTracker = (ctx?: NextPageContext): Tracker => createDefaultTracker({
  intentManifest: intentManifest as DeliveryAPIResult,
  storage: {
    scopes: indexedDbScopeStorage({
      scoringStorage: createNextCookieStorage(ctx),
    }),
  },
  logLevelThreshold,
});

export const localTracker = createLocalTracker();
